export enum BotConfigurationsActionTypes {
  GET_BOT_CONFIGURATION_REQUEST = 'bot-configuration/GET_BOT_CONFIGURATION_REQUEST',
  GET_BOT_CONFIGURATION_SUCCESS = 'bot-configuration/GET_BOT_CONFIGURATION_SUCCESS',
  GET_BOT_CONFIGURATION_ERROR = 'bot-configuration/GET_BOT_CONFIGURATION_ERROR',
  UPDATE_BOT_CONFIGURATION_REQUEST = 'bot-configuration/UPDATE_BOT_CONFIGURATION_REQUEST',
  UPDATE_BOT_CONFIGURATION_SUCCESS = 'bot-configuration/UPDATE_BOT_CONFIGURATION_SUCCESS',
  UPDATE_BOT_CONFIGURATION_ERROR = 'bot-configuration/UPDATE_BOT_CONFIGURATION_ERROR',
}
